module.exports = __webpack_public_path__ + "img/plane-left.dbb8eee2.svg";